import React, {useState} from 'react';
import {useTranslation} from "react-i18next";
import {Button, Container} from 'react-bootstrap';
import MatchingManualsTable from './MatchingManualsTable';
import {IManualModel} from "../../types/manualFinder";
import {handleDownloadManual} from "../../utils/manualFinderUtils";
import {PaginationControls} from "../../components";

interface MatchingManualsProps {
    manuals: IManualModel[];
    setIsLoading: (loading: boolean) => void;
}

export const ManualFinderSpecialTools: React.FC<MatchingManualsProps> = ({manuals, setIsLoading}) => {
    const {t} = useTranslation();
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);

    const totalPages = Math.ceil(manuals.length / itemsPerPage);

    const handlePageChange = (pageNumber: number) => setCurrentPage(pageNumber);
    const handleItemsPerPageChange = (value: string | null) => {
        if (value) {
            setItemsPerPage(Number(value));
            setCurrentPage(1);
        }
    };

    const paginatedManuals = manuals.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

    if (manuals.length <= 0) {
        return (
            <Container className="w-80 d-flex justify-content-center align-items-start" style={{paddingTop: '20vh'}}>
                <span>{t("SpecialTool.NoMatchingManuals")}</span>
            </Container>
        );
    }

    return (
        <div className="d-flex flex-column gap-3 p-lg-3">
            <div className="d-flex justify-content-end">
                <Button variant="secondary" onClick={() => handleDownloadManual(manuals)}>
                    {t("SpecialTool.DownloadButton")}
                </Button>
            </div>

            <MatchingManualsTable manuals={paginatedManuals} setIsLoading={setIsLoading}/>

            <PaginationControls
                totalPages={totalPages}
                currentPage={currentPage}
                handlePageChange={handlePageChange}
                itemsPerPage={itemsPerPage}
                handleItemsPerPageChange={handleItemsPerPageChange}
            />
        </div>
    );
};

